import { BaseService } from '../base/service';
import { EmptyService } from '../text/emptyService';
import { HtmlService } from './htmlService';

const EMPTY_HTML_REGEXP = /^(?:\s*<div\s*>(?:\s|&nbsp;)*(?:<br\s*\/?>(?:\s|&nbsp;)*)?<\/div>\s*|(?:\s|&nbsp;)*(?:<br\s*\/?>(?:\s|&nbsp;)*)?)$/i;

export function createHtmlEmptyService(htmlService: HtmlService): EmptyService {
  return new HtmlEmptyService(htmlService);
}

class HtmlEmptyService extends BaseService implements EmptyService {
  constructor(htmlService: HtmlService) {
    super(htmlService);

    this.htmlService = htmlService;
  }

  private readonly htmlService: HtmlService;

  get isEmpty() {
    return EMPTY_HTML_REGEXP.test(this.htmlService.html);
  }
}
